import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SubscriptionQueryVariables = Types.Exact<{
  now: Types.Scalars['String']['input'];
}>;

export type SubscriptionQuery = {
  primaryUserSubscription: {
    __typename: 'UserSubscription';
    trial: boolean | null;
    nextPaymentTime: Types.Scalars['DateTime']['output'] | null;
    lastPaymentTime: Types.Scalars['DateTime']['output'] | null;
    isInContract: boolean | null;
    addons: Array<{
      __typename: 'UserAddon';
      product:
        | { __typename: 'LiveProduct'; id: string; title: string | null }
        | { __typename: 'PrimaryProduct'; id: string; title: string | null }
        | null;
    }> | null;
    product:
      | { __typename: 'LiveProduct'; id: string; title: string | null }
      | { __typename: 'PrimaryProduct'; id: string; title: string | null }
      | null;
    alert: {
      __typename: 'UserSubscriptionAlert';
      id: string | null;
      title: string | null;
      subTitle: string | null;
      displayOnEveryVisit: boolean | null;
      uid: string | null;
      onCloseDate: Types.Scalars['Date']['output'] | null;
      tracking: {
        __typename: 'TrackingData';
        identifier: string | null;
        detail: Types.Scalars['TrackingDataDetail']['output'] | null;
      } | null;
      buttons: Array<{
        __typename: 'UserSubscriptionAlertButton';
        text: string | null;
        hideOnClick: boolean | null;
        actionType: string | null;
        actionValue: string | null;
        color: string | null;
        theme: string | null;
        tracking: {
          __typename: 'TrackingData';
          identifier: string | null;
          detail: Types.Scalars['TrackingDataDetail']['output'] | null;
        } | null;
      }> | null;
    } | null;
  } | null;
};

export const SubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Subscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'now' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryUserSubscription' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextPaymentTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPaymentTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInContract' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alert' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'now' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'now' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayOnEveryVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onCloseDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracking' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttons' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hideOnClick' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'actionValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tracking' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionQuery, SubscriptionQueryVariables>;
